import PopoverContent, { Sections } from 'components/PopoverContent'
import React from 'react'

type BaseProps = {
  label: React.ReactNode
  sections?: Sections
  tooltip?: string
  className?: string
}

type Props =
  | (BaseProps & { triggerType?: 'hover'; ariaLabel?: string })
  | (BaseProps & { triggerType: 'click'; ariaLabel: string })

/**
 * A label with an adjacent tooltip popover
 */
const TooltipLabel: React.FC<Props> = props => {
  const { label, sections, tooltip, className = '' } = props
  const newSections = sections ? sections : [{ content: tooltip || '' }]

  if (props.triggerType === 'click') {
    return (
      <span className={className}>
        <span className="mr-xs">{label}</span>
        <PopoverContent
          sections={newSections}
          triggerType={props.triggerType}
          ariaLabel={props.ariaLabel}
        />
      </span>
    )
  }

  return (
    <span className={className}>
      <span className="mr-xs">{label}</span>
      <PopoverContent
        sections={newSections}
        triggerType={props.triggerType}
        ariaLabel={props.ariaLabel}
      />
    </span>
  )
}

export default TooltipLabel
